/** Exporta recorte 1:1 a partir da imagem + pan/zoom da UI. */

export const CROP_OUTPUT_SIZE = 800

export type CropViewState = {
  /** Zoom relativo ao “cover” (1 = cobre a área). */
  zoom: number
  /** Deslocamento em px na área de preview (centro = 0,0). */
  panX: number
  panY: number
}

/** Escala base para cobrir um quadrado `box` com a imagem. */
export function coverScale(imgW: number, imgH: number, box: number): number {
  return Math.max(box / imgW, box / imgH)
}

/**
 * Desenha a imagem no canvas quadrado com cover + zoom + pan
 * (mesma matemática do preview do modal).
 */
export function paintCroppedSquare(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  box: number,
  state: CropViewState,
): void {
  const base = coverScale(img.naturalWidth, img.naturalHeight, box)
  const scale = base * Math.max(1, state.zoom)
  const dw = img.naturalWidth * scale
  const dh = img.naturalHeight * scale
  const dx = (box - dw) / 2 + state.panX
  const dy = (box - dh) / 2 + state.panY
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, box, box)
  ctx.drawImage(img, dx, dy, dw, dh)
}

export function exportCroppedJpeg(
  img: HTMLImageElement,
  state: CropViewState,
  size = CROP_OUTPUT_SIZE,
  quality = 0.88,
): Promise<Blob> {
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size
  const ctx = canvas.getContext('2d')
  if (!ctx) return Promise.reject(new Error('Canvas indisponível.'))
  paintCroppedSquare(ctx, img, size, state)
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Falha ao gerar JPEG.'))),
      'image/jpeg',
      quality,
    )
  })
}

/** Limita pan para a imagem continuar cobrindo o quadrado. */
export function clampPan(
  imgW: number,
  imgH: number,
  box: number,
  zoom: number,
  panX: number,
  panY: number,
): { panX: number; panY: number } {
  const scale = coverScale(imgW, imgH, box) * Math.max(1, zoom)
  const dw = imgW * scale
  const dh = imgH * scale
  const maxX = Math.max(0, (dw - box) / 2)
  const maxY = Math.max(0, (dh - box) / 2)
  return {
    panX: Math.min(maxX, Math.max(-maxX, panX)),
    panY: Math.min(maxY, Math.max(-maxY, panY)),
  }
}
